import { useSelector } from 'react-redux';
import { selectTopAuctionBetPosition } from '../../../../../../../../../../../selectors/betPosition';
import {
  selectCurrentBet,
  selectIsAuctionEnabled,
  selectIsAutobrokerEnabled,
} from '../../../../../../../../../../../selectors/auction';
import { selectIsTopServiceUnavailable } from '../../../../../../../../../../../selectors/publishTerms';
import { getTopBetServiceTitle } from '../../ServiceContainer/utils';
import { useService } from '../../ServiceContainer/hooks';
import { EServiceId } from '../../../../../../../../../../../types/reducers/publishTerms';

export const useTopService = () => {
  const { price } = useService(EServiceId.top);
  const topAuctionBetPosition = useSelector(selectTopAuctionBetPosition);
  const isAutobrokerEnabled = useSelector(selectIsAutobrokerEnabled);
  const isTopServiceUnavailable = useSelector(selectIsTopServiceUnavailable);
  const isAuctionEnabled = useSelector(selectIsAuctionEnabled);
  const currentBet = useSelector(selectCurrentBet);

  const topBetServiceTitle = getTopBetServiceTitle(currentBet, price);

  // На мобилках позиция отображается внутри PromotionSectionContainer
  const showBetPosition = Boolean(topAuctionBetPosition);
  const showPrice = Boolean(isAutobrokerEnabled || isTopServiceUnavailable || !isAuctionEnabled);

  return {
    showBetPosition,
    showPrice,
    topBetServiceTitle,
    isTopServiceUnavailable,
    topAuctionBetPosition,
  };
};
